import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"minus-large, remove, delete"} maskId="square-filled-radius-0-stroke-1-IconMinusLarge"><path fillRule="evenodd" clipRule="evenodd" d="M3 11.5H21V12.5H3V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMinusLarge;
